import SearchStore from './search-store';
import EventStore from './event-store';
import ConfigSettingsStore from './config-settings-store';

export default [SearchStore, EventStore, ConfigSettingsStore];
